import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AuthStingService } from '../../auth/auth.service';
import { NotificationWizardResource, NotificationWizardSteps } from './notification-wizard-type';
import moment from 'moment';
import { UserResource } from '../../api-users/model/userResource';

@Component({
    selector: 'notification-wizard-dialog',
    templateUrl: './notification-wizard-dialog.component.html',
    styleUrls: ['./notification-wizard-dialog.component.scss'],
    standalone: false
})
export class NotificationWizardComponent implements OnInit {
    protected readonly notificationWizardSteps = NotificationWizardSteps;

    loggedUser?: UserResource;
    notificationWizard: NotificationWizardResource;

    communication?: any;

    constructor(
        public dialogRef: MatDialogRef<NotificationWizardComponent>,
        private toastr: ToastrService,
        private _changeDetectorRef: ChangeDetectorRef,
        private _authService: AuthStingService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.communication = data?.communication;

        if (sessionStorage.getItem('notificationWizard')) {
            // @ts-ignore
            this.notificationWizard = JSON.parse(sessionStorage.getItem('notificationWizard')) as NotificationWizardResource;
        } else {
            this.notificationWizard = { step: NotificationWizardSteps.Filter };
        }
    }

    patchCommunication() {

        if (this.communication) {
            this.notificationWizard.androidMessage = this.communication.androidMessage;
            this.notificationWizard.iosMessage = this.communication.iosMessage;
            this.notificationWizard.message = this.communication.message;
            this.notificationWizard.subject = this.communication.subject;
            this.notificationWizard.whatsappMessage = this.communication.whatsappMessage;
            this.notificationWizard.sendTime = moment(this.communication.sendAt, 'DD.MM.YYYY HH.mm').format('YYYY-MM-DD HH:mm').toString()
            this.notificationWizard.attachedDocuments = this.communication.attachments;
            this.notificationWizard.offers = this.communication.offers;

            this.notificationWizard.userList = this.communication.users.map((user: any) => {
                return { ...user, checked: true }; // Add 'checked' property with value 'true'
            });

            this.notificationWizard.id = this.communication.id;
            this.notificationWizard.step = NotificationWizardSteps.Summaray;

            sessionStorage.setItem('notificationWizard', JSON.stringify(this.notificationWizard));
        }

    }

    async ngOnInit(): Promise<void> {
        this.loggedUser = await this._authService.profile().toPromise();
        this._changeDetectorRef.markForCheck();
        this.patchCommunication();
    }

    nextStep() {
        this.notificationWizard = JSON.parse(sessionStorage.getItem('notificationWizard')) as NotificationWizardResource;
        this._changeDetectorRef.markForCheck();
    }

    back() {
        switch (this.notificationWizard.step) {

            case NotificationWizardSteps.Text: {
                this.notificationWizard.step = NotificationWizardSteps.Filter;
                sessionStorage.setItem('notificationWizard', JSON.stringify(this.notificationWizard));
                break;
            }
            case NotificationWizardSteps.Summaray: {
                this.notificationWizard.step = NotificationWizardSteps.Text;
                sessionStorage.setItem('notificationWizard', JSON.stringify(this.notificationWizard));
                break;
            }
        }
        this._changeDetectorRef.markForCheck();
    }

    logStorage() {
        const wizard = JSON.parse(sessionStorage.getItem('notificationWizard')) as NotificationWizardResource;
        console.log('session:', wizard);
        console.log('COM: ', this.communication);
        console.log('WIZ: ', this.notificationWizard);
    }

    reset(){
        sessionStorage.removeItem('notificationWizard');
        this.communication = null;
        this._changeDetectorRef.markForCheck();
        this.dialogRef.close();
    }
}
